import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import TokenSetWrapper from "./TokenSetWrapper";
import { useSelector } from "react-redux";
import ForoFourPage from "ForoFourPage";
import "./App.css";
import MobileSidebar from "components/sidebar/MobileSidebar";
import DefaultLayout from "layouts/Default";

const App = () => {
  //login user state
  const loginUser = useSelector((state) => state?.authReducer?.data);
  return (
    <TokenSetWrapper>
      <MobileSidebar />
      <Routes>
        {/* Default route based on authentication status */}
        <Route
          path="/"
          element={
            loginUser?.token ? (
              <Navigate to="/admin" />
            ) : (
              <Navigate to="/auth" />
            )
          }
        />

        {/* Admin route for authenticated users */}
        <Route
          path="/admin/*"
          element={loginUser?.token ? <AdminLayout /> : <Navigate to="/auth" />}
        />

        {/* Auth route for unauthenticated users */}
        <Route path="/auth/*" element={<AuthLayout />} />

        {/* route for default layout and render page*/}
        <Route path="/default/machine-management/bulk-upload-guide" element={<DefaultLayout />} />

        {/* Catch-all route to handle 404 */}
        <Route path="*" element={<ForoFourPage />} />
      </Routes>
    </TokenSetWrapper>
  );
};

export default App;
